<template>
  <div v-if="isSelf && functionalityEnabled">
    <div v-if="twoFactorEnabled">
      {{ $t('two_factor_authorization') }}:
      <span class="text-primary font-weight-bold">{{ $t('activated') }}</span>
      <span class="ml-2">(<a class="text-muted pointer" @click="turnOff">{{ $t('turn_off') }}</a>)</span>
    </div>
    <div v-if="!twoFactorEnabled">
      {{ $t('two_factor_authorization') }}:
      <span class="text-muted font-weight-bold">{{ $t('turned_off') }}</span>
      <span class="ml-2">(<a class="text-primary pointer" @click="turnOn">{{ $t('turn_on') }}</a>)</span>
    </div>
    <TwoFactorAuthenticationModal v-if="showModal"
                                  @hide="showModal = false"/>
    <TwoFactorCodeInputModal v-if="showCodeModal"
                             @codeEntered="modalResolve"
                             @hide="showCodeModal = false"
    />
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, nextTick, onBeforeMount, ref } from "vue"
import { useStore } from "vuex"
import TwoFactorAuthenticationModal from "@/components/parts/staff/TwoFactorAuthenticationModal.vue"
import TwoFactorCodeInputModal from "@/components/parts/staff/TwoFactorCodeInputModal.vue"
import { UsersService } from "@/services/api/users.api.service"

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
})

const store = useStore()
let bvModal = null
let noty = null
let i18n = null

const showModal = ref(false)
const showCodeModal = ref(false)
const modalResolve = ref(() => {})
const functionalityEnabled = true

const authorizedUser = computed(() => store.state.auth.user)
const isSelf = computed(() => Number(props.user.id) === Number(authorizedUser.value.id))
const twoFactorEnabled = computed(() => authorizedUser.value.two_factor_enabled && authorizedUser.value.two_factor_confirmed_at)

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
  noty = instance?.appContext?.app?.noty
  i18n = instance?.ctx?.$i18n
})

const turnOn = async () => {
  showModal.value = true
  await nextTick()
  bvModal.show('two-factor-authentication-modal')
}

const turnOff = async () => {
  showCodeModal.value = true
  await nextTick()
  const code = await openTwoFactor()
  if(!code) return
  try {
    const res = await UsersService.twofactorDisable(code)
    if(res.data) {
      store.dispatch('init').then().catch(console.error)
      noty.info(i18n.t('success_message'))
    }
  } catch (e) {
    console.error(e)
  }
}

const openTwoFactor = async () => {
  bvModal.show('two-factor-code-input-modal')
  return new Promise((resolve) => {
    modalResolve.value = resolve
  })
}
</script>
